export enum CookieNames {
  ApiVersion = 'IOGAS_apiV'
}